import { intl } from "LocaleWrapper";
import { Button, Textarea } from "@cofano/cck";
import Grid from "@mui/material/Grid2";
import { CustomDialog } from "components/dialogs/Dialogs";
import { useState } from "react";

type CommentDialogProps = {
	onClose: () => void;
	onUpdate: (value?: string) => Promise<void>;
	comment?: string;
}

const CustomerUpdateCommentDialog = ({ onClose, onUpdate, comment }: CommentDialogProps) => {
	const [ value, setValue ] = useState(comment);
	const [ loading, setLoading ] = useState(false);

	const handleUpdate = async () => {
		setLoading(true);
		try {
			await onUpdate(value);
		} finally {
			setLoading(false);
		}
	};

	return (
		<CustomDialog
			maxWidth="sm"
			open
			onClose={onClose}
			title={intl.formatMessage({ id: "COMMENT" })}
			actions={<>
				<Button loading={loading} onClick={handleUpdate}>
					{intl.formatMessage({ id: "SAVE" })}
				</Button>
			</>}
		>
			<Grid container spacing={3}>
				<Grid size={12}>
					<Textarea
						value={value}
						style={{ minHeight: "100px" }}
						onChange={(ev) => setValue(ev.target.value)}
						onFocus={(e) => {
							const length = e.target.value.length;
							e.target.setSelectionRange(length, length);
						}}
						autoFocus />
				</Grid>
			</Grid>
		</CustomDialog>
	);
};

export default CustomerUpdateCommentDialog;
